import { remove } from "remove-accents";

export default function standardizeValue(value) {
  return remove(value).replace(/\s/g, "").toLowerCase();
}
